// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d1e0e1dc","977":"c7daca7d"}[chunkId] + ".chunk.js";
};